import React from 'react'
import useSingleStation from '../../../hooks/useSingleStation'
import { useGetSumKwhPayGoAnalysis } from '../../../../paygo/hooks/usePaygo';
import { Paygo } from '../../../../paygo/types/paygo.types';
import { Filter } from '../../../../../utils/genericAPI/useGenericAPI';
import { useFilterAnalysis } from '../../../../../common/analysis/filter/hook';

export default function NbKwhProvided({ stationId, startDate, endDate }:{stationId?: string, startDate?: string | null, endDate?: string | null}) {
    const {filter} = useFilterAnalysis()
    const { stationId: paramId } = useSingleStation()

    const stationIdFound = stationId || paramId;

    const prefilter : Filter<Partial<Paygo>> | undefined = stationIdFound ? {
            paygo_station: `=${stationIdFound}`,
           paygo_created_at: filter.startDate && filter.startDate ?`<btw>[${filter.startDate },${filter.stopDate}]`: undefined
        } : undefined

    const {  sumKwhPaygoAnalysisQuery } = useGetSumKwhPayGoAnalysis({
        
        preFilter: prefilter,

    })




    if (sumKwhPaygoAnalysisQuery.isLoading) {
        return (
            <>...</>
        )
    }
    if (sumKwhPaygoAnalysisQuery.isError) {
        return <>-</>
    }


    if (!sumKwhPaygoAnalysisQuery.data || !sumKwhPaygoAnalysisQuery.data?.data || sumKwhPaygoAnalysisQuery.data?.data.length === 0) {
        return <>0</>
    }


  return (
    <>{Number(sumKwhPaygoAnalysisQuery.data?.data[0]?.total).toFixed(2)}</>
  )
}
